import React, { useState } from "react";
import { AppDispatch, RootState } from "src/Store/store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { tooglePleaseLogin } from "src/Store/reducer";
import CartDrawer from "./AdminComponents/CartDrawer";
import LoginCustomer from "./AllTabs/LoginCustomer";
import LoginImage from "src/assets/images/website-images/login-register-icon.png";
import GradientBtn from "./WebsiteComponents/GradientBtn";

const PleaseLoginModal: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { pleaseLoginModal } = useSelector(
    (store: RootState) => store.appReducer
  );

  const [showLoginScreen, setShowLoginScreen] = useState(false);

  return (
    <>
      <CartDrawer
        isOpen={showLoginScreen}
        onClose={() => {
          setShowLoginScreen(false);
          dispatch(tooglePleaseLogin(false));
        }}
      >
        <LoginCustomer
          onBack={() => {
            setShowLoginScreen(false);
            dispatch(tooglePleaseLogin(false));
          }}
          onSuccess={() => {
            setShowLoginScreen(false);
            dispatch(tooglePleaseLogin(false));
          }}
        />
      </CartDrawer>
      {pleaseLoginModal && !showLoginScreen && (
        <div className="modal-overlay">
          <div className="w-[90%] h-[90%] p-5 bg-modal-image rounded-[20px] 2xl:max-w-[750px] 2xl:max-h-[450px] md:max-w-[600px] md:max-h-[370px] bg-white  flex flex-col items-center justify-center 2xl:gap-8 gap-4">
            <img
              src={LoginImage}
              alt="login-modal-image"
              className="w-[100px] 2xl:w-[150px]"
            />
            <p className="font-size-35px text-[#2F2F31] font-Lexend-Medium max-w-[75%] text-center">
              Please Login/Register First To Access This Section
            </p>
            <div className="flex justify-center items-center gap-4 w-full">
              <GradientBtn
                ButtonText="Cancel"
                onPress={() => {
                  dispatch(tooglePleaseLogin(false));
                  setShowLoginScreen(false);
                }}
                isOutline
                btnExtraStyle={{ width: "fit-content", minWidth: "150px" }}
              />
              <GradientBtn
                ButtonText="Login"
                onPress={() => {
                  setShowLoginScreen(true);
                }}
                btnExtraStyle={{ width: "fit-content", minWidth: "150px" }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PleaseLoginModal;
